import hyperdom from 'hyperdom'

export default class DateOfBirthPicker {
  constructor (options) {
    this.binding = options.binding
    this.placeholder = options.placeholder
    this.config = options.config
    this.isDisabled = options.isDisabled
    this.isDateInUSFormat = ['US', 'CA'].includes(this.config.countryCode)
    this.date = {
      day: '',
      month: '',
      year: '',
    }
    this.isFieldInvalid = options.isFieldInvalid
  }

  update (key, target) {
    this.binding.setIsDobUpdated(true)
    const parsedValue = this.parseInputValue(target.value)

    this.date[key] = parsedValue
    const newDate = this.isDateInUSFormat
      ? `${this.date.month}/${this.date.day}/${this.date.year}`
      : `${this.date.day}/${this.date.month}/${this.date.year}`
    this.binding.set(newDate)

    if (parsedValue.length === 2 && key !== 'year') {
      target.nextElementSibling.focus()
    }
  }

  parseInputValue (stringValue) {
    return stringValue.replace(/\D/g, '')
  }

  selectedRange (ev) {
    ev.target.setSelectionRange(4, 4)
  }

  prePopulateDateWithZero (target, type) {
    if(target.value.length === 1 && type !== 'year') {
      target.value = '0' + target.value
      this.update(type, target)
    }
  }

  onKeyDown (ev) {
    const isKeyBackspace = ev.keyCode === 8 || ev.charCode === 8
    if(isKeyBackspace && ev.target.selectionStart === 0 && ev.target.selectionEnd === 0) {
      this.binding.setIsDobUpdated(true)
      const prevSibling = ev.target.previousElementSibling
      prevSibling.focus()
      if(prevSibling.setSelectionRange) {
        prevSibling.setSelectionRange(0, 4)
      }
      ev.preventDefault()
    }
  }

  onBlur (type, ev) {
    this.prePopulateDateWithZero(ev.target, type)
    const fullDateWasTyped = this.binding.get() && this.binding.get().length === 10

    if (!this.binding.get() || this.date[type] === '' || fullDateWasTyped && this.binding.isDobUpdated()) {
      this.binding.fieldVisited()
      if (!this.isFieldInvalid() && (this.binding.scrollTo || typeof this.binding.scrollTo === 'function')) {
        this.binding.scrollTo()
      }
    }
    this.binding.setIsDobUpdated(false)
    ev.target.offsetParent.classList.remove('active')
  }

  selectField (ev) {
    const parentElementClasses = ev.target.offsetParent.classList
    this.selectedRange(ev)
    if (!ev.target.offsetParent.classList.contains('active')) {
      parentElementClasses.add('active')
    }
  }

  renderInputField (type) {
    const isYearField = type === 'year'
    const placeholders = {
      day: 'DD',
      month: 'MM',
      year: 'YYYY',
    }

    return <input
      type="text"
      id={`dateOfBirth-${type}`}
      className={`form-custom-date-picker ${type}`}
      name="dateOfBirth"
      onfocus={(ev) => this.selectField(ev)}
      inputMode='numeric'
      maxLength={ isYearField ? 4 : 2 }
      value={this.date[type]}
      placeholder={placeholders[type]}
      oninput={(ev) => {this.update(type, ev.target)}}
      onkeydown={(ev) => this.onKeyDown(ev, type)}
      onblur={(ev) => this.onBlur(type, ev)}
      disabled={this.isDisabled}
    />
  }

  isFieldFilled (type) {
    return this.date[type].length >= 2
  }

  render () {
    const fieldsOrder = this.isDateInUSFormat ? ['month', 'day', 'year'] : ['day', 'month', 'year']
    const pickedDate = this.binding.get() && this.binding.get().split('/') || ['', '', '']
    this.date = this.isDateInUSFormat
      ? {day: pickedDate[1], month: pickedDate[0], year: pickedDate[2]}
      : {day: pickedDate[0], month: pickedDate[1], year: pickedDate[2]}

    return <label
      for="dateOfBirth"
      className={['form-custom-date-picker__label', {'disabled': this.isDisabled}, {'invalid': this.isFieldInvalid()}]}
      onclick={(ev) =>  ev.target.children[1] && ev.target.children[1].focus()}
    >
      <span className='form-custom-date-picker__placeholder'>{this.placeholder}</span>
      {fieldsOrder.map(fieldType => this.renderInputField(fieldType))}
      <span className={this.isFieldFilled(fieldsOrder[0]) ? '': 'disabled'}>/</span>
      <span className={this.isFieldFilled(fieldsOrder[1]) ? '': 'disabled'}>/</span>
    </label>
  }
}
